<template>
  <v-list-group
    eager
    data-testid="navigation-drawer-list-icon"
    class="navigation-drawer-list-icon"
    :prepend-icon="icon"
  >
    <template v-slot:activator>
        <v-list-item-title
          data-testid="navigation-drawer-list-title"
          class="navigation-drawer-list-title"
        >
          {{ title }}
        </v-list-item-title>
    </template>
    <div v-for="item of items" :key="item.id">
      <navigation-drawer-item
        v-if="item.type === 'item'"
        :icon="item.icon"
        :title="item.title"
        :route_to="item.route_to"
        :roles="item.roles"
      />
      <navigation-drawer-list
        v-if="item.type === 'list'"
        :icon="item.icon"
        :title="item.title"
        :items="item.items"
      />
    </div>
  </v-list-group>
</template>

<script>
import NavigationDrawerItem from "./NavigationDrawerItem";

export default {
  components: { NavigationDrawerItem },
  props: {
    icon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      required: true,
      default: ""
    },
    items: {
      type: Array,
      required: true
    },
    roles: {
      type: Array
    }
  },
  name: "NavigationDrawerList"
};
</script>
